import * as z from 'zod/v4';

export const wagerStatusSchema = z.boolean().transform((isActive) => (isActive ? 'Active' : 'Finished'));
export type WagerStatus = z.infer<typeof wagerStatusSchema>;
